import React, { useEffect } from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import WhyChooseUs from './components/WhyChooseUs';
import Services from './components/Services';
import Results from './components/Results';
import AboutChristina from './components/AboutChristina';
import Gallery from './components/Gallery';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import StructuredData from './components/StructuredData';

// Remove Emergent badge
const useRemoveBadge = () => {
  useEffect(() => {
    const removeBadge = () => {
      // Find and remove any emergent badge elements
      const selectors = [
        '[data-testid="emergent-badge"]',
        '.emergent-badge',
        'div[class*="emergent"]',
        'iframe[src*="emergent"]'
      ];
      
      selectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          el.style.display = 'none';
          el.remove();
        });
      });
      
      // Also check for fixed positioned elements in bottom right
      document.querySelectorAll('div').forEach(el => {
        const style = window.getComputedStyle(el);
        if (style.position === 'fixed' && 
            style.bottom !== 'auto' && 
            style.right !== 'auto' &&
            el.textContent?.includes('Emergent')) {
          el.style.display = 'none';
          el.remove();
        }
      });
    };
    
    // Run immediately and on interval to catch dynamically added badges
    removeBadge();
    const interval = setInterval(removeBadge, 1000);
    
    return () => clearInterval(interval);
  }, []);
};

const Home = () => {
  useRemoveBadge();
  
  return (
    <div className="min-h-screen">
      <StructuredData />
      <Header />
      <main>
        <Hero />
        <WhyChooseUs />
        <Services />
        <Results />
        <AboutChristina />
        <Gallery />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
